<script lang="ts">
  import { searchFilter, updateSearchFilter } from "state/page";

  function onChange(this: HTMLInputElement) {
    if (this.checked) {
      updateSearchFilter("ntbCuratedImages", true);
    } else {
      updateSearchFilter("ntbCuratedImages", false);
    }
  }
</script>

<label>
  <input
    type="checkbox"
    class="org-input"
    checked={$searchFilter.ntbCuratedImages}
    on:change={onChange}
  />
  <span>Utvalgte bilder (NTB)</span>
</label>

<style>
  /** Alignment is off with default values, but shouldn't need this much tweaking */
  label {
    display: flex;
    gap: var(--org-xsmall);
    align-items: center;
  }
</style>
